import React from 'react';
import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <>
    <path d="M21.77 9.79999L20.97 7.99999L19.21 4.03999C18.74 2.99999 18 2.14999 16.3 2.14999H7.70001C6.00001 2.14999 5.26001 2.99999 4.79001 4.03999L3.03001 7.99999L2.23001 9.79999C1.77001 10.85 2.02001 12.39 2.79001 13.24L9.64001 20.78C10.94 22.21 13.06 22.21 14.36 20.78L21.21 13.24C21.98 12.39 22.23 10.85 21.77 9.79999Z" />
  </>,
  'Diamonds',
);
